"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var WelcomeMessageType;
(function (WelcomeMessageType) {
    WelcomeMessageType["FOLLOWERS"] = "followers";
    WelcomeMessageType["SUBSCRIBERS"] = "subscribers";
})(WelcomeMessageType = exports.WelcomeMessageType || (exports.WelcomeMessageType = {}));
class WelcomeMessagesProvider extends DataProvider_1.default {
    get fragments() {
        return {
            WelcomeMessage: () => `
        ... on WelcomeMessage {
          subject {
            ${this.getFragment("Subject")}
          }
          text
          enabled
          pricePackageId
          files {
            urlPart
            uuid
            metadata
            publicAccess
          }
        }
      `,
        };
    }
    findByUser({ userId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("welcomeMessagesFind", { userId }, this.getFragment("WelcomeMessage"));
        });
    }
    update({ userId, messages, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("welcomeMessagesUpdate", { userId, messages }, this.getFragment("WelcomeMessage"));
        });
    }
}
exports.WelcomeMessagesProvider = WelcomeMessagesProvider;
//# sourceMappingURL=WelcomeMessagesProvider.js.map